var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIconBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4119 17.047H2.79999V18.1578C2.79999 18.1814 2.6857 18.4241 2.65713 18.4682C2.23383 19.1271 1.21353 18.943 1.02406 18.189L1 11.3241C1.13534 9.99339 2.22856 8.91377 3.55712 8.84302H23.7104C25.0119 8.94649 26.0337 9.97589 26.2058 11.2731C26.0765 13.4369 26.4021 15.8548 26.2149 17.9889C26.1517 18.7086 25.4231 19.1286 24.8081 18.7239C24.681 18.6402 24.4111 18.2993 24.4111 18.157V17.0462L24.4119 17.047Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.512 7.02403H20.8105V5.85617C20.8105 5.27718 20.1233 4.58026 19.603 4.40147C19.0248 4.20365 16.9662 4.23713 16.2782 4.28735C15.5241 4.34289 14.5076 5.02535 14.5076 5.85617V7.02403H12.7068V5.85617C12.7068 5.27718 12.0196 4.58026 11.4993 4.40147C10.9211 4.20365 8.86251 4.23713 8.17454 4.28735C7.42041 4.34289 6.40388 5.02535 6.40388 5.85617V7.02403H3.70239V1.35741C3.70239 1.13144 4.1272 0.689402 4.37457 0.671143L22.8835 0.684837C23.115 0.712227 23.5128 1.14818 23.5128 1.35741V7.02403H23.512Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconBed);
export default __webpack_public_path__ + "static/media/feature-icon-bed.3d11ec93.svg";
export { ForwardRef as ReactComponent };